import React, { useMemo } from 'react';

import clsx from 'clsx';

import { convertToMargin, MarginType } from '@utils/convert-to-margin';

import classes from './divider.module.scss';

type Props = {
  margin?: MarginType;
  className?: string;
};

export const Divider = ({ margin = [20, 0], className }: Props) => {
  const marginValue = useMemo(() => convertToMargin(margin), [margin]);

  return (
    <div
      className={clsx(classes.divider, className)}
      style={{ margin: marginValue }}
    ></div>
  );
};
